"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokingSlipVersionCoverDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const opportunity_cover_entity_1 = require("./opportunity-cover.entity");
const opportunity_broking_slip_version_entity_1 = require("./opportunity-broking-slip-version.entity");
let BrokingSlipVersionCoverDetails = class BrokingSlipVersionCoverDetails {
};
exports.BrokingSlipVersionCoverDetails = BrokingSlipVersionCoverDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_map_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broking_slip_version_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "brokingSlipVersionId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionCoverDetails.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_response", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionCoverDetails.prototype, "coverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], BrokingSlipVersionCoverDetails.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], BrokingSlipVersionCoverDetails.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionCoverDetails.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokingSlipVersionCoverDetails.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_cover_entity_1.OpportunityCoverMap, (coverMap) => coverMap.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "cover_map_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokingSlipVersionCoverDetails.prototype, "coverMap", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_broking_slip_version_entity_1.BrokingSlipVersionDetails, (brokingSlip) => brokingSlip.coverDetails, {
        nullable: false,
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "broking_slip_version_id" }),
    tslib_1.__metadata("design:type", Object)
], BrokingSlipVersionCoverDetails.prototype, "brokingSlipVersion", void 0);
exports.BrokingSlipVersionCoverDetails = BrokingSlipVersionCoverDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_broking_slip_version_cover_map_details")
], BrokingSlipVersionCoverDetails);
